import { motion } from "framer-motion";

const bars = [0.4, 0.7, 1, 0.5, 0.8, 0.6, 0.9, 0.3, 0.75, 0.55, 0.85, 0.45];

const AudioEqualizer = ({ className = "" }: { className?: string }) => (
  <div className={`flex items-end gap-[3px] h-8 ${className}`}>
    {bars.map((intensity, i) => (
      <motion.div
        key={i}
        className="w-[3px] rounded-full bg-primary"
        animate={{
          height: [`${intensity * 20}%`, `${intensity * 100}%`, `${intensity * 40}%`, `${intensity * 90}%`, `${intensity * 20}%`],
        }}
        transition={{
          duration: 1.2 + i * 0.1,
          repeat: Infinity,
          ease: "easeInOut",
          delay: i * 0.08,
        }}
      />
    ))}
  </div>
);

export default AudioEqualizer;
